import { createSelector, Selector } from 'reselect';
import createCachedSelector from 're-reselect';
import { getStringProp } from '@mews/fp';
import { ApplicationState } from '@mews-commander/types';
import parentSelector from '../selector';
import { MODULE_NAME } from './constants';

const moduleSelector: Selector<
    ApplicationState,
    { asyncState: Record<string, AsyncState>; meta: Record<string, MetaState> }
> = createSelector(parentSelector, (state) => state[MODULE_NAME]);

interface AsyncState {
    isFetching?: boolean;
    hasFailed?: boolean;
    hasSucceeded?: boolean;
}

const getAsyncState = createCachedSelector(
    moduleSelector,
    getStringProp('scope'),
    (state, scope) => state.asyncState[scope] ?? {}
)(getStringProp('scope'));

export const isFetching = createSelector(getAsyncState, (state) => Boolean(state.isFetching));
export const hasFailed = createSelector(getAsyncState, (state) => Boolean(state.hasFailed));
export const hasSucceeded = createSelector(getAsyncState, (state) => Boolean(state.hasSucceeded));

interface MetaState {
    selectedEntityId?: string;
    isAdding?: boolean;
    isEditing?: boolean;
    isDeleting?: boolean;
}

const getMeta = createCachedSelector(
    moduleSelector,
    getStringProp('scope'),
    (state, scope) => state.meta[scope] ?? {}
)(getStringProp('scope'));

export const getSelectedEntityId = createSelector(getMeta, (state) => state.selectedEntityId as string);
export const isAdding = createSelector(getMeta, (state) => Boolean(state.isAdding));
export const isEditing = createSelector(getMeta, (state) => Boolean(state.isEditing));
export const isDeleting = createSelector(getMeta, (state) => Boolean(state.isDeleting));
